import { useParams } from "react-router-dom";

import { ModalControlled2 } from "@/ui2/molecules/Modal";
import { usePatientDetails } from "@/features/patient/api/queries/usePatientDetails";
import type { UUID } from "@/core/types";

import { AcuityHistoryTimeline } from "./AcuityHistoryTimeline";

type AcuityHistoryModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
};

type Params = {
  patientId: UUID;
};

export function AcuityHistoryModal({ isModalOpen, setIsModalOpen }: AcuityHistoryModalProps) {
  const { patientId } = useParams<Params>();
  const { data: patientDetails } = usePatientDetails({ patientId });

  const { first_name, last_name } = patientDetails;

  const fullName = `${first_name} ${last_name}`;

  return (
    <ModalControlled2
      className="tw:min-w-2xl"
      isOpen={isModalOpen}
      onOpenChange={setIsModalOpen}
      title={`${fullName}'s Acuity History`}
    >
      <AcuityHistoryTimeline />
    </ModalControlled2>
  );
}
